<!--
  ~ Copyright (c) 2025.
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
  -->

@switch (bestelstatus) {
  @case ("aanvraag") {
    <div class="row">
      <div class="col-md-6 mb-3">
        <p><em>Maak een nieuwe zoekvraag</em></p>
        <form #form="ngForm" class="mt-4">
          <div class="mb-3">
            <label for="discprofiel" class="form-label">DISC-uitslag</label>
            <select id="discprofiel" name="discprofiel" required class="form-select" [(ngModel)]="model.disc">
              @for (dp of discs; track $index) {
                <option [value]="dp">{{ dp }}</option>
              }
            </select>
          </div>
          <div class="mb-3">
            <label for="schoolprofiel" class="form-label">Schoolprofiel</label>
            <select id="schoolprofiel" name="schoolprofiel" required class="form-select"
                    [(ngModel)]="model.profielkeuze">
              @for (pr of profielkeuzes; track $index) {
                <option [value]="pr">{{ pr }}</option>
              }
            </select>
          </div>
          @if (basisdata?.payment_nodig) {
            <div class="mb-3"><label for="factuurgegevens" class="form-label">Facturering</label>
              <textarea id="factuurgegevens" class="form-control" rows="5" required name="factuurgegevens"
                        [(ngModel)]="model.factuurgegevens"></textarea>
              <small>Dit is de aanhef (naam+adres) boven de downloadbare factuur</small></div>
          }
          <div class="mb-3">
            <button class="btn btn-primary" [disabled]="form.invalid" (click)="bestellen()">Ophalen passende
              studies @if (basisdata?.payment_nodig) {
                (met betaalverplichting)
              }</button>
          </div>
        </form>
      </div>
      <div class="col-md-6 mb-3">
        <p><em>Heb je al een bewaarcode? Vul die dan hier in om de keuzelijst op te halen.</em></p>
        <label class="form-label" for="ophalen_bewaarcode">Bewaarcode</label>
        <input class="form-control" id="ophalen_bewaarcode" name="ophalen_bewaarcode" [(ngModel)]="ophaalbewaarcode">
        <button class="mt-2 btn btn-primary" (click)="ophalenBewaarcode()">Ophalen gegevens</button>
      </div>
    </div>

  }
  @case ("onbekend") {
    <h4>Onbekende bewaarcode</h4>
    <p>De bewaarcode ({{ bewaarcode ?? "?" }}) is onbekend of niet langer geldig.</p>
    <p><a [href]="mijnUrl">Terug</a></p>
  }
  @case ("mislukt") {
    <h4>Betaling mislukt</h4>
    <p>Er is iets misgegaan met je betaling.</p>
    <p><a [href]="mijnUrl">Terug</a></p>
  }
  @case ("geannuleerd") {
    <h4>Betaling geannuleerd</h4>
    <p>Je betaling is geannuleerd.</p>
    <p><a [href]="mijnUrl">Terug</a></p>
  }
  @case ("fout") {
    <h4>Fout</h4>
    <p>Er is een interne fout opgetreden.</p>
    <p>Probeer de pagina te verversen.</p>
    <p>Noteer de bewaarcode <b>{{ mijnBewaarcode }}</b> (of sla <a href="{{mijnUrl}}?bewaarcode={{bewaarcode}}">deze
      link</a> op). De code is een korte tijd geldig om je resultaten opnieuw op te halen.</p>
    <p><a [href]="mijnUrl">Nieuwe bestelling</a></p>
  }
  @case ("open") {
    <h4>In afwachting van de betaling</h4>
    <p>We wachten nog op de bevestiging van je betaling. Deze pagina wordt vanzelf bijgewerkt.</p>
    <p>Je kan hier ook later terugkomen. Gebruik dan de bewaarcode <b>{{ mijnBewaarcode }}</b> of <a
      href="{{mijnUrl}}?bewaarcode={{bewaarcode}}">deze link.</a></p>
  }
  @default {
    @if (bestelstatus === 'betaald' || bestelstatus === 'gratis') {
      <h4>Je bestelling met bewaarcode {{ mijnBewaarcode }}</h4>
      <div class="row">
        <div class="col-md-6 mb-3">
          Noteer deze bewaarcode (of sla <a href="{{mijnUrl}}?bewaarcode={{bewaarcode}}">deze link</a> op). De code is
          een
          korte tijd geldig om je resultaten opnieuw op te halen.
        </div>
        @if (bestelstatus === 'betaald') {
          <div class="col-md-6 mb-3 text-right">
            <button class="btn btn-link" (click)="factuurPDF()">Download je factuur</button>
          </div>
        }
      </div>

      <div class="filterrij">
        <div class="row">
          @if (niveaus?.length > 1) {
            <div class="col">
              <label for="filterniveau" class="form-label">Niveau</label>
              <select id="filterniveau" class="form-select" [(ngModel)]="filter.niveau" (change)="doeFilter()">
                <option [ngValue]="null"></option>
                @for (niveau of niveaus; track niveau) {
                  <option [value]="niveau">{{ niveau }}</option>
                }
              </select>
            </div>
          }
          @if (sectoren?.length > 1) {
            <div class="col-6">
              <label for="filtersector" class="form-label">Sector</label>
              <ng-multiselect-dropdown id="filtersector" placeholder="Kies..." [data]="sectoren"
                                       [settings]="dropdownSettings" [(ngModel)]="filter.sectoren"
                                       (ngModelChange)="doeFilter()"></ng-multiselect-dropdown>
            </div>
          }
          <div class="col">
            <label for="filterprofiel" class="form-label">Profiel</label>
            <div id="filterprofiel" class="form-text">{{ model.profielkeuze }}</div>
          </div>
          <div class="col">
            <label for="filterdisc" class="form-label">DISC</label>
            <div id="filterdisc" class="form-text">{{ model.disc }}</div>
          </div>
          <div class="col">
            <button class="btn btn-lg btn-primary" [disabled]="studiesGefilterd.length === 0"
                    title="Genereer een PDF van de gefilterde lijst, om op te slaan of te printen"
                    (click)="studielijstPDF()"><span class="fas fa-file-pdf"></span></button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <small>Studies: {{ studies.length }}. Gefilterd: {{ studiesGefilterd.length }}</small>
          </div>
        </div>
      </div>
      <div class="wpaiska_studietable_container mt-2">
        <table #studietable class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th>Niveau</th>
            <th>Sector</th>
            <th>Studierichting</th>
            <th>Voorwaarden</th>
          </tr>
          </thead>
          <tbody>
            @for (studie of studiesGefilterd; track studie.id; let rijnr = $index; ) {
              <tr [title]="studie.studierichting" (click)="selectedRijNr = rijnr"
                  [class.wpaipska_select]="selectedRijNr === rijnr">
                <td class="wpaipska_niveau">{{ studie.niveau }}</td>
                <td class="wpaipska_sector">{{ studie.sector }}</td>
                <td class="wpaipska_studierichting" [innerHTML]="breakStudierichting(studie)"></td>
                <td class="wpaipska_profielkeuze">{{ studie.Profielkeuze[0]?.opmerking }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="wpaipska_textcenter">
        N.B. deze lijst is op geen enkele wijze bindend en geeft slechts een indicatie van passende studierichtingen.
        Controleer altijd de eisen van de opleiding.
      </div>
    }
  }
}
